import { flushPendingCarousels } from '../carousel/carousel';

interface ModalConfig {
  modal: HTMLElement;
}

export class Modal {
  private __modal: HTMLElement;
  private readonly __overlay: HTMLElement | null;

  constructor(config: ModalConfig) {
    if (!config.modal) {
      throw new Error('Modal element is required');
    }
    this.__modal = config.modal;
    this.__overlay = this.__modal.closest('.cmp-modal__overlay');

    this.init();
  }

  private init(): Modal {
    this.bindEvents();

    return this;
  }

  private handleCloseModal = () => {
    this.close();
  };

  private handleCloseOnOverlayClick = (e: Event) => {
    if (e.target === this.__overlay) {
      this.close();
    }
  };

  private handleCloseByPressingEsc = (e: KeyboardEvent) => {
    if (e.key === 'Escape' && this.isOpen()) {
      this.close();
    }
  };

  private bindEvents(): void {
    const closeModalButton = this.__modal.querySelector(
      '.cmp-modal__close-modal-button .cmp-button'
    ) as HTMLButtonElement;
    const formInModal = this.__modal.querySelector('form') as HTMLFormElement;

    if (closeModalButton) {
      closeModalButton.addEventListener('click', this.handleCloseModal);
    }
    if (formInModal && this.__modal.hasAttribute('data-close-modal-on-form-submition')) {
      formInModal.addEventListener('submit', this.handleCloseModal);
    }
    if (this.__overlay && this.__modal.hasAttribute('data-close-modal-on-overlay-click')) {
      this.__overlay.addEventListener('click', this.handleCloseOnOverlayClick);
    }

    document.addEventListener('keydown', this.handleCloseByPressingEsc);
  }

  private destroy(): void {
    // Remove event listeners to prevent memory leaks
    const closeModalButton = this.__modal.querySelector(
      '.cmp-modal__close-modal-button .cmp-button'
    ) as HTMLButtonElement;
    if (closeModalButton) {
      closeModalButton.removeEventListener('click', this.handleCloseModal);
    }

    if (this.__overlay) {
      this.__overlay.removeEventListener('click', this.handleCloseOnOverlayClick);
    }
  }

  public open(): void {
    this.__modal.setAttribute('open', '');

    if (this.__overlay) {
      this.__overlay.setAttribute('open', '');
    }

    flushPendingCarousels(this.__modal);

    this.__modal.focus();
  }

  public close(): void {
    this.__modal.removeAttribute('open');

    if (this.__overlay) {
      this.__overlay.removeAttribute('open');
    }
  }

  public isOpen(): boolean {
    return this.__modal.hasAttribute('open');
  }

  public toggle(): void {
    if (this.isOpen()) {
      this.close();
    } else {
      this.open();
    }
  }
}
